import request from "@/utils/request";

export function handleListApi(data) {
  return request({
    url: "/admin/admin_users",
    method: "get",
    params: data
  });
}

export function handleCreateStoreApi(data) {
  if (data.id) {
    return request({
      url: "/admin/admin_users/" + data.id,
      method: "put",
      data
    });
  } else {
    return request({
      url: "/admin/admin_users",
      method: "post",
      data
    });
  }
}

export function handleDeleteApi(data) {
  return request({
    url: "/admin/admin_users/" + data.id,
    method: "delete"
  });
}

export function handleRoleListApi() {
  const data = {
    limit: 99999,
    type: "user-transfer"
  };
  return request({
    url: "/admin/admin_roles",
    method: "get",
    params: data
  });
}

export function handleUserRoleListApi(row) {
  const data = {
    id: row.id
  };
  return request({
    url: "/admin/get_user_roles",
    method: "get",
    params: data
  });
}

export function handlePermissionListApi() {
  const data = {
    limit: 99999,
    type: "user-transfer"
  };
  return request({
    url: "/admin/admin_permissions",
    method: "get",
    params: data
  });
}

export function handleUserPermissionListApi(row) {
  const data = {
    id: row.id
  };
  return request({
    url: "/admin/get_user_permissions",
    method: "get",
    params: data
  });
}

export function handleGetUserListApi() {
  return request({
    url: "/admin/get_user_list",
    method: "get"
  });
}

export function handleSetUserPwdApi(data) {
  return request({
    url: "/user/set_user_password",
    method: "get",
    params: data
  });
}

// 获取城市组别
export function getAdminCityApi() {
  return request({
    url: "/admin/get_admin_city_group",
    method: "get"
  });
}
